import { MenuCategoryT, MenuT } from 'types/frontend/Menu';
import pcMenu from 'menuStructures/pcMenu';

export function getMenuCategory(path: string): MenuCategoryT | null {
  const pathItems = path.split('/');
  console.log(pathItems);

  if (pathItems.length < 3) return null;
  if (pathItems[1] !== 'teacherSide') return null;

  // 여러개의 path접두어가 하나의 category가 될 수 있다.
  if (pathItems[2] === 'bill') return 'bill';
  if (pathItems[2] === 'textbook') return 'textbook';

  if (pathItems[2] === 'management') return 'management';
  if (pathItems[2] === 'post') return 'post';
  if (pathItems[2] === 'attendance') return 'attendance';

  if (pathItems[2] === 'homework') return 'homeworkAndSchedule';

  if (pathItems[2] === 'lessonReport') return 'report';
  if (pathItems[2] === 'exam') return 'report';
  if (pathItems[2] === 'analysisReport') return 'report';

  if (pathItems[2] === 'counsel') return 'counsel';
  if (pathItems[2] === 'message') return 'message';
  if (pathItems[2] === 'setting') return 'setting';

  return null;
}

export const getSectionsOfCategory = (category: MenuCategoryT): MenuT => {
  if (category === 'management') return pcMenu.managementMenu;
  if (category === 'textbook') return pcMenu.textbookMenu;
  if (category === 'bill') return pcMenu.billMenu;
  if (category === 'post') return pcMenu.postMenu;
  if (category === 'attendance') return pcMenu.attendanceMenu;
  if (category === 'homeworkAndSchedule') return pcMenu.homeworkAndScheduleMenu;
  if (category === 'report') return pcMenu.reportMenu;
  if (category === 'counsel') return pcMenu.counselMenu;
  if (category === 'message') return pcMenu.messageMenu;
  if (category === 'setting') return pcMenu.settingMenu;
  if (category === 'etc') return pcMenu.etcMenu;
  else return [];
};
